"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Candidate = void 0;
var Candidate_1 = require("./Candidate");
Object.defineProperty(exports, "Candidate", { enumerable: true, get: function () { return Candidate_1.Candidate; } });
